/* eslint-disable no-unused-vars */
import React from 'react';
import { Dialog, DialogContent, IconButton, Grid, Tooltip, InputAdornment, Box } from '@mui/material';
import styles from 'custom/style.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps } from 'custom/components';
import { BrowseIcon, CloseIconBtn } from 'custom/constants';

const AddDocModal = (props) => {
  const { modal, onClose, fields, errors, onSubmit, onChange } = props;

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={modal === 'addDoc'} onClose={onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          {'Add New Attachment'}
          <CloseIconBtn onClick={onClose} />
        </CustomDialogTitle>
        <Box component='form' 
        // onSubmit={onSubmit} 
          autoComplete='off'>
          <DialogContent>
            <StyledCard sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} >
                  <CustomInputLabel htmlFor='name' required>Name</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='name'
                    placeholder='Name'
                    type='text'
                    name='name'
                    onChange={onChange}
                    value={fields.name || ''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <Tooltip sx={{ display:'none' }} title={fields?.file?.name}>
                            <span className={styles.fileName}>{fields?.file?.name}</span>
                          </Tooltip>
                          <IconButton size='small'>
                            <input
                              accept='application/pdf,image/*'
                              style={{ display: 'none' }}
                              id='file'
                              type='file'
                              name='file'
                              onChange={onChange}
                            />
                            <label htmlFor='file' className={`${styles.fs0} ${styles.pointer}`}>
                              <BrowseIcon />
                            </label>
                          </IconButton> 
                        </InputAdornment>
                      )
                    }}
                    error={Boolean(errors.name || errors.remark)}
                    helperText={errors.name || errors.remark}
                  />
                </Grid>
              </Grid>
            </StyledCard>
          </DialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close </CustomButton>
            <CustomButton variant='contained' onClick={onSubmit}> Submit </CustomButton>
          </CustomDialogAction>
        </Box>
      </Dialog>
    </div>
  );
};
export default AddDocModal;